import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { HeadBannar } from '../components/head-bannar'
import { HorizontalArticle, HorizontalArticleImageContainer, HorizontalArticleText, HorizontalArticleTextContainer, HorizontalArticleTitle } from '../components/horizontal-article'
import { Section } from '../components/section'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'

const Outer = styled.div``

type StaffPageProps = {

}
export const StaffPage: FunctionComponent<StaffPageProps> = () => {
  return <Outer>
  <HeadBannar desktop={() => <BannerImage src="/images/header_06.jpg" />} mobile={() => <BannerImage src="/images/header_06_mobile.jpg" />}></HeadBannar>
  <ContentContainer>
    {/* <SectionNavigator labelMap={new Map([['outstandings', 'OUTSTANDINGS'], ['staff', '紹介者']])} /> */}
    <Section id="about" style={{maxWidth: '76rem'}}>
      <SectionTitle>OUTSTANDINGS</SectionTitle>
      <SectionSpaceMedium />
      <DecoratedFrame leftTop="/images/dec_06_01.png" rightBottom="/images/dec_06_02.png">
        <AutoImage src="/images/img_09.jpg" mobileSrc="/images/img_09_mobile.jpg" />
        <AutoImage src="/images/img_10.jpg" mobileSrc="/images/img_10_mobile.jpg" />
      </DecoratedFrame>
      <SectionSpaceMedium />
      <SectionTextSmall>
        ムロノキッズは20代の若い職員が多く、職場はいつも活気に溢れています。<br />
        年功序列がほとんどないため意見も言いやすく、<br />
        お互いの考えをスムーズに共有出来ることで業務がはかどる環境も魅力のひとつです。<br />
        就職後のサポートも手厚く、基本的な業務に関する定期研修を実施し、<br />
        ピアノはプロの先生による2年間のレッスンも用意しているので、<br />
        “誰もがキラリと輝ける”職場環境が整っています。<br />
        「様々な形の家族、家庭を支援したい」という思いは、園児だけでなく、<br />
        職員に対しても同様に考えていますので結婚、出産を経ても長く働き続けられる職場づくりを目指しています。
      </SectionTextSmall>
    </Section>
    <Section id="staff" style={{maxWidth: '76rem'}}>
      <HorizontalArticle>
        <HorizontalArticleImageContainer right="/images/dec_07_01.png">
          <AutoImage src="/images/img_11.jpg" mobileSrc="/images/img_11_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer>
          <HorizontalArticleTitle>
            理事長
          </HorizontalArticleTitle>
          <HorizontalArticleTitle>
            村田 晃<small>（むらた あきら）</small>
          </HorizontalArticleTitle>
          <HorizontalArticleText>
            地域の子育て支援拠点としての役割を果たすために、保護者の就労の有無で園を選ぶということのない幼保連携型認定こども園の運営を志しました。若い職員が多く、極力自由闊達な雰囲気を維持した教務運営を心掛けております。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticle>
      <SectionSpaceLarge />
      <HorizontalArticle>
        <HorizontalArticleTextContainer>
          <HorizontalArticleTitle>
            園長
          </HorizontalArticleTitle>
          <HorizontalArticleTitle>
            北見 宏<small>（きたみ ひろし）</small>
          </HorizontalArticleTitle>
          <HorizontalArticleText>
          本良いもの、創造性をふくらませられるものを園内に配置するようにして物志向での園整備を心掛けています。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
        <HorizontalArticleImageContainer left="/images/dec_07_02.png">
          <AutoImage src="/images/img_12.jpg" mobileSrc="/images/img_12_mobile.jpg" />
        </HorizontalArticleImageContainer>
      </HorizontalArticle>
      <SectionSpaceLarge />
      <HorizontalArticle>
        <HorizontalArticleImageContainer right="/images/dec_07_03.png">
          <AutoImage src="/images/img_13.jpg" mobileSrc="/images/img_13_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer>
          <HorizontalArticleTitle>
            キッズアミ<small>（小規模保育所）</small>責任者
          </HorizontalArticleTitle>
          <HorizontalArticleTitle>
            林田 麻衣<small>（はやしだ まい）</small>
          </HorizontalArticleTitle>
          <HorizontalArticleText>
            初めての子どもだけの施設に無理なく子ども達が集えるような雰囲気づくりが出来るように配慮しております。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticle>
      <SectionSpaceMedium />
    </Section>
    <BlogSection />
  </ContentContainer>
  </Outer>
}